import { Component, HostListener, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { KaizenService } from '../Services/Kaizen.Service';
import { ActivatedRoute, Router } from '@angular/router';
import { Actual, ChangedActuals } from '../models/Actual';
import { ActualsAccount } from '../models/ActualsAccount';
import { ActualService } from '../Services/Actual.Service';
import { KaizenMonthlySaving } from '../models/Kaizen';
import { AppComponent } from '../app.component';
import { ActualDTO } from '../models/ActualDTO';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmdialogService } from '../Services/confirm-dialog.service';
import { firstValueFrom } from 'rxjs';
import { CompletionYears } from '../models/CompletionYears';
@Component({
    selector: 'app-actuals',
    templateUrl: './actuals.component.html',
    styleUrls: ['./actuals.component.css'],
    standalone: false
})
export class ActualsComponent implements OnInit {

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: Event) {
    const e = event as KeyboardEvent;
    e.preventDefault();
  }
  formActuals!: UntypedFormGroup;
  progressFormGroup!: UntypedFormGroup;
  accountArray!: UntypedFormArray;
  kaizenId: number = 0;
  kaizenNumber: number = 0;
  kaizenDescription: string = '';
  actualsArray: Actual[] = [];
  kmsArray: KaizenMonthlySaving[] = [];
  monthArray: string[] = [];
  actualsAccountArray: ActualsAccount[] = []; 
  isCancelDelete: boolean = false;
  isSubmitBpaks: boolean = false;
  isKaizenComplete: boolean = false;
  cancelKaizenYesNo: string = 'No';
  completeYesNo: string = 'No';
  submitBpaksYesNo: string = 'No';
  isEditable: boolean = true;
  days: { Id: string, Name: string }[] = [];
  monthList = [
    { Value: 1, Text: 'Jan' },
    { Value: 2, Text: 'Feb' },
    { Value: 3, Text: 'Mar' },
    { Value: 4, Text: 'Apr' },
    { Value: 5, Text: 'May' },
    { Value: 6, Text: 'Jun' },
    { Value: 7, Text: 'Jul' },
    { Value: 8, Text: 'Aug' },
    { Value: 9, Text: 'Sep' },
    { Value: 10, Text: 'Oct' },
    { Value: 11, Text: 'Nov' },
    { Value: 12, Text: 'Dec' }    
  ];
  actualHeaderMonthList = [    
    { Value: 4, Text: 'Apr' },
    { Value: 5, Text: 'May' },
    { Value: 6, Text: 'Jun' },
    { Value: 7, Text: 'Jul' },
    { Value: 8, Text: 'Aug' },
    { Value: 9, Text: 'Sep' },
    { Value: 10, Text: 'Oct' },
    { Value: 11, Text: 'Nov' },
    { Value: 12, Text: 'Dec' },
    { Value: 1, Text: 'Jan' },
    { Value: 2, Text: 'Feb' },
    { Value: 3, Text: 'Mar' }    
  ];
  kaizenAccountArray!: any;
  kaizenMonthlySavingAry!: any[];
  accountsKaizenMonthlySaving: any[][] = [[], [], [], [], []];
  actualArray: any[][] = [[], [], [], [], []];
  gapActual: number[][] = new Array(5);
  actualDTO: ActualDTO = new ActualDTO();
  actualsAccount!: ActualsAccount[];
  fiscalYear: string[] = ['', '', '', '', '', '', '', '', '', '', '', ''];
  twtImpactPlan: number[] = [];
  costImpactActual: number[] = [];
  twtImpactGap: number[] = [];
  twtImpactAmountPlan: number[] = [];
  twtImpactAmountActual: number[] = [];
  twtImpactAmountGap: number[] = [];
  twtPlanCumulative: number = 0;
  twtActualCumulative: number = 0;
  twtGapCumulative: number = 0;
  costImpactPlan: number[] = [];
  twtImpactActual: number[] = [];
  costImpactGap: number[] = [];
  changedActuals: ChangedActuals = new ChangedActuals();
  multipleCurrencies = false;
  changedToCompleted = false;
  yearList: CompletionYears[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private appComponent: AppComponent,
    private actualService: ActualService,
    private KaizenService: KaizenService,
    private snackBar: MatSnackBar,
    private router: Router, 
    private confirmdialogservice: ConfirmdialogService,

  ) { }
  ngOnInit(): void {

    this.kaizenId = Number(this.route.snapshot.paramMap.get('id'));
    const role = localStorage.getItem(`adroleNormalized`);

    if (role != `Submitter` && role != `SystemAdmin` && role != `ISAdmin` && role != `CMDApproverPlus`) {
      this.isEditable = false;
    }
    else {
      this.isEditable = true;
    }
    this.formActuals = this.formBuilder.group({
      kaizenCancelDelete: [''],
      kaizenComplete: [''],
      reasonForCancellation: [''],
      completionDay: [''],
      completionMonth: [''],
      completionYear: [''],
      submitBpaks: [''],
      accountArray: new UntypedFormArray([])
    });

    this.loadCompletionYears();
    this.initLoadExistingKaizen();


    for (let i = 0; i < 5; i++) {
      const row: number[] = [];
      for (let j = 0; j < 12; j++) {
        row.push(0);
      }
      this.gapActual[i] = row;
    }

    this.changedActuals.actuals = [];
  }

  cancel() {
    this.confirmdialogservice.openDialog().afterClosed().subscribe(res => {
      if (res) {
        this.router.navigate(['./kaizens']);
      }
    });
  }

  onSubmit(formActuals: UntypedFormGroup) {
    
    if (this.isCancelDelete == true || this.isKaizenComplete == true) 
    {
      //set variables to defaults which will be used if Kaizen cancelled and changed to real values if complete
      let CompletionDay = '00';
      let CompletionMonth = '00';
      let CompletionYear = '0000'
      let Complete = this.isCancelDelete == true ? false : true
      let reason = formActuals.value.reasonForCancellation;

      if(this.isKaizenComplete == true)
      {      
        CompletionDay = formActuals.value.completionDay;
        CompletionMonth = formActuals.value.completionMonth;
        CompletionYear = formActuals.value.completionYear;
        reason = 'completed';
      }
      
        if(this.isCancelDelete == true || (this.changedToCompleted == true && this.isKaizenComplete == true))
        {
          this.KaizenService.putCompleteDelete(Complete, 
                                              this.kaizenId, 
                                              CompletionDay, 
                                              CompletionMonth, 
                                              CompletionYear, 
                                              reason, 
                                              this.isSubmitBpaks, 
                                              this.appComponent.ademail).subscribe();      
        }
      
      for (var i = 0; i <= this.actualsAccount.length - 1; i++) {
        for (var m = 0; m < 12; m++) {
          const kaizenActualId = this.actualsAccount[i].actualArray[m].kaizenActualId;
          let isPresent = false;
          for (const actual of this.changedActuals.actuals) {
            if (actual.kaizenActualId === kaizenActualId) {
              isPresent = true;
              break;
            }
          }
          if (isPresent == false && this.actualsAccount[i].actualArray[m].actualValue == null) 
          {
            let updatededActual: Actual = new Actual();
            updatededActual.kaizenActualId = this.actualsAccount[i].actualArray[m].kaizenActualId;
            updatededActual.modifiedBy = this.appComponent.ademail;
            updatededActual.modifiedOn = new Date().toISOString();;
            if (this.actualsAccount[i].savingsMeasureId == 2) {
              updatededActual.actualValue = this.accountsKaizenMonthlySaving[i][m].processReduction;
            }
            else if (this.actualsAccount[i].savingsMeasureId == 3) {
              updatededActual.actualValue = this.accountsKaizenMonthlySaving[i][m].twtReduction;
            }
            else if (this.actualsAccount[i].savingsMeasureId == 4 && this.accountsKaizenMonthlySaving[i][m].monthlySavings > 0) 
            {
              
              updatededActual.actualValue = this.accountsKaizenMonthlySaving[i][m].costPerUnitSavings;
              
            }
            else if (this.actualsAccount[i].savingsMeasureId == 5) {
              updatededActual.actualValue = this.accountsKaizenMonthlySaving[i][m].monthlySavings;
            }
            this.changedActuals.actuals.push(updatededActual);
          }
        }
      }
    }
    if (this.changedActuals.actuals.length > 0) {
      //console.log('actuals', this.changedActuals.actuals);
      this.actualService.updateKaizenActuals(this.changedActuals).subscribe(
        {
          next: data => {
            this.changedActuals.actuals = [];
          },
          error: error => { console.log('There was an error!', error); }
        });
    }
    // this.snackBar.open("Actuals saved Successfully!");
    // setTimeout(() => {
    //   this.snackBar.dismiss();
    // }, 2000);
    this.router.navigate(['./kaizens']);
  }

  getAccountFormArray() {
    return this.formActuals.get('accountArray') as UntypedFormArray;
  }

  cancelDeleteChecked(e: any) {
    this.isCancelDelete = e.target.checked;
    this.cancelKaizenYesNo = this.isCancelDelete ? 'Yes' : 'No';

  }

  kaizenCompleteChecked(e: any) {
    this.isKaizenComplete = e.target.checked;
    this.completeYesNo = this.isKaizenComplete ? 'Yes' : 'No';
  }

  changeCompletionMonth(e: any) {
    this.changedToCompleted  = true;
    this.days.length = 0;
    var year = this.formActuals.value.completionYear;
    var numberOfDaysinMonth: number = 31;
    var selectedMonth = e.target.options[e.target.options.selectedIndex].text;
    if (selectedMonth == 'Apr' || selectedMonth == 'Jun' || selectedMonth == 'Sep' || selectedMonth == 'Nov') {
      numberOfDaysinMonth = 30;
    }
    else if (selectedMonth == 'Feb') {
      if ((year % 4 == 0) && (0 != year % 100) || (0 == year % 400)) {
        numberOfDaysinMonth = 29;
      } else {
        numberOfDaysinMonth = 28;
      }
    }
    for (var x = 1; x <= numberOfDaysinMonth; x++) {
      this.days.push({ Id: x.toString(), Name: x.toString() });
    }

  }

  submitBpaksChecked(e: any) {
    this.isSubmitBpaks = e.target.checked;
    this.submitBpaksYesNo = this.isSubmitBpaks ? 'Yes' : 'No';
  }

  async loadCompletionYears()
  {
    await firstValueFrom(this.actualService.getKaizenCompletionYears()).then((data) =>
    {
       this.yearList = data.data;
    })
  }

  async initLoadExistingKaizen() {
    await firstValueFrom(this.KaizenService.getKaizenActualsByKaizen(this.kaizenId)).then((data) => {
      this.actualDTO =data?.data ?? new ActualDTO();
      if (this.actualDTO.kaizenState == 'Complete')
      {
        this.isKaizenComplete = true;
      }
      this.actualsAccount = this.actualDTO.kaizenActualAccountArray;
      console.log('this.actualsAccount', this.actualsAccount);
      for (var y = 0; y < 12; y++) {
        if (y >= 3) {
          this.fiscalYear[y] = this.actualDTO.fiscalYear;
        }
        else {
          this.fiscalYear[y] = ('' + Number(Number(this.actualDTO.fiscalYear) + 1));
        }
      }
    });
    this.accountArray = this.formActuals.get('accountArray') as UntypedFormArray;
    let currentCurrencyCode = this.actualsAccount[0].currencyCode;
    for (var i = 0; i <= this.actualsAccount.length - 1; i++) {
      
      if(this.multipleCurrencies || currentCurrencyCode != this.actualsAccount[i].currencyCode)
      {
        this.multipleCurrencies = true;
      }
      currentCurrencyCode = this.actualsAccount[i].currencyCode;
      this.accountsKaizenMonthlySaving[i] = this.actualsAccount[i].kaizenMonthlySaving;
      this.actualArray[i] = this.actualsAccount[i].actualArray;
      for (var m = 0; m < 12; m++) 
      {
        if (this.actualsAccount[i].savingsMeasureId == 2) {
          this.gapActual[i][m] = this.actualArray[i][m].actualValue - this.accountsKaizenMonthlySaving[i][m].processReduction;
        }
        else if (this.actualsAccount[i].savingsMeasureId == 3) {
          this.gapActual[i][m] = this.actualArray[i][m].actualValue - this.accountsKaizenMonthlySaving[i][m].twtReduction;
        }
        else if (this.actualsAccount[i].savingsMeasureId == 4) 
        {
          if(this.accountsKaizenMonthlySaving[i][m].monthlySavings != 0)
          {
            this.gapActual[i][m] = this.actualArray[i][m].actualValue - this.accountsKaizenMonthlySaving[i][m].costPerUnitSavings;
          }
        }
        else if (this.actualsAccount[i].savingsMeasureId == 5) {
          this.gapActual[i][m] = this.actualArray[i][m].actualValue - this.accountsKaizenMonthlySaving[i][m].monthlySavings;
          ;
        }
      }
      this.accountArray.push(this.loadMonthlySavingsFormArray(i));
    }
    this.netTotal();
  }
  loadMonthlySavingsFormArray(i: number): UntypedFormGroup {
    return this.formBuilder.group(
      {
        kaizenAccountId: [0],
        kaizenId: [0],
        gLAccountImpactAreaID: [0],
        savingsMeasureID: [0],
        ActualsMon0: [this.actualArray[i][0].actualValue == null ? '' : this.actualArray[i][0].actualValue],
        ActualsMon1: [this.actualArray[i][1].actualValue == null ? '' : this.actualArray[i][1].actualValue],
        ActualsMon2: [this.actualArray[i][2].actualValue == null ? '' : this.actualArray[i][2].actualValue],
        ActualsMon3: [this.actualArray[i][3].actualValue == null ? '' : this.actualArray[i][3].actualValue],
        ActualsMon4: [this.actualArray[i][4].actualValue == null ? '' : this.actualArray[i][4].actualValue],
        ActualsMon5: [this.actualArray[i][5].actualValue == null ? '' : this.actualArray[i][5].actualValue],
        ActualsMon6: [this.actualArray[i][6].actualValue == null ? '' : this.actualArray[i][6].actualValue],
        ActualsMon7: [this.actualArray[i][7].actualValue == null ? '' : this.actualArray[i][7].actualValue],
        ActualsMon8: [this.actualArray[i][8].actualValue == null ? '' : this.actualArray[i][8].actualValue],
        ActualsMon9: [this.actualArray[i][9].actualValue == null ? '' : this.actualArray[i][9].actualValue],
        ActualsMon10: [this.actualArray[i][10].actualValue == null ? '' : this.actualArray[i][10].actualValue],
        ActualsMon11: [this.actualArray[i][11].actualValue == null ? '' : this.actualArray[i][11].actualValue]
      });
  }
  onActualChangeEvent(e: any, i: number) {
    const controlName = e.target.getAttribute('formControlName');
    const controlMon = controlName.replace('ActualsMon', '');
    let updatededActual: Actual = new Actual();
    updatededActual.kaizenActualId = this.actualsAccount[i].actualArray[controlMon].kaizenActualId;
    updatededActual.modifiedBy = this.appComponent.ademail;
    updatededActual.modifiedOn = new Date().toISOString();;
    updatededActual.actualValue = e.target.value;
    var filteredActualsAry = this.changedActuals.actuals.filter(x => x.kaizenActualId != this.actualsAccount[i].actualArray[controlMon].kaizenActualId);
    this.changedActuals.actuals = filteredActualsAry;
    this.changedActuals.actuals.push(updatededActual);
    if (this.actualsAccount[i].savingsMeasureId == 2) {
      this.gapActual[i][controlMon] = e.target.value - this.accountsKaizenMonthlySaving[i][controlMon].processReduction;
    }
    else if (this.actualsAccount[i].savingsMeasureId == 3) {
      this.gapActual[i][controlMon] = e.target.value - this.accountsKaizenMonthlySaving[i][controlMon].twtReduction;
    }
    else if (this.actualsAccount[i].savingsMeasureId == 4) {
      this.gapActual[i][controlMon] = e.target.value - this.accountsKaizenMonthlySaving[i][controlMon].costPerUnitSavings;
    }
    else if (this.actualsAccount[i].savingsMeasureId == 5) {
      this.gapActual[i][controlMon] = e.target.value - this.accountsKaizenMonthlySaving[i][controlMon].monthlySavings;
    }
    this.netTotal();
  }
  netTotal() {
    this.twtImpactPlan = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.costImpactPlan = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtImpactActual = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.costImpactActual = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtImpactGap = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.costImpactGap = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtImpactAmountPlan = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtImpactAmountActual = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtImpactAmountGap = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.twtGapCumulative = 0;
    this.twtActualCumulative = 0;
    this.twtPlanCumulative = 0;
    var actualUpdated = 0;
    for (var i = 0; i <= this.actualsAccount.length - 1; i++) {
      this.twtPlanCumulative = 0;
      for (var m = 0; m < 12; m++) {
        var actualValAry = this.changedActuals.actuals.filter(x => x.kaizenActualId == this.actualArray[i][m].kaizenActualId);
        const currentAcMonProcessReduction = this.accountsKaizenMonthlySaving[i][m].processReduction;
        const currentAcMonTWTReduction = this.accountsKaizenMonthlySaving[i][m].twtReduction;
        const currentAcMonCPUSavings = this.accountsKaizenMonthlySaving[i][m].costPerUnitSavings;
        const currentAcMonTotalCost = this.accountsKaizenMonthlySaving[i][m].monthlySavings;
        const currentAcMonNoOfShifts = this.accountsKaizenMonthlySaving[i][m].numberOfShifts;
        const currentAcMonWorkingDays = this.accountsKaizenMonthlySaving[i][m].workingDays;
        const currentAcMonWorkingHours = this.accountsKaizenMonthlySaving[i][m].workingHours;
        const currentAcMonStandardRate = this.accountsKaizenMonthlySaving[i][m].standardRate;
        const currentAcMonCapacity = this.accountsKaizenMonthlySaving[i][m].capacity;
        
        if (actualValAry.length !== 0) {
          actualUpdated = actualValAry[0].actualValue;
        }
        else {
          actualUpdated = this.actualArray[i][m].actualValue
        }
        if (this.actualsAccount[i].savingsMeasureId == 2) {
          this.twtPlanCumulative += currentAcMonProcessReduction;
          this.twtImpactPlan[m] += currentAcMonNoOfShifts * currentAcMonWorkingDays * currentAcMonWorkingHours * this.twtPlanCumulative;
          this.twtActualCumulative += Number(actualUpdated);
          this.twtImpactActual[m] += this.twtActualCumulative * currentAcMonNoOfShifts * currentAcMonWorkingDays * currentAcMonWorkingHours;
          this.twtImpactGap[m] += this.twtImpactActual[m] - this.twtImpactPlan[m];
          //this.gapActual[i][m] * currentAcMonNoOfShifts * currentAcMonWorkingDays * currentAcMonWorkingHours * this.twtGapCumulative;
          this.twtGapCumulative += this.twtImpactGap[m];

          this.twtImpactAmountPlan[m] += this.twtImpactPlan[m] * currentAcMonStandardRate;
          this.twtImpactAmountActual[m] += this.twtImpactActual[m] * currentAcMonStandardRate;
          this.twtImpactAmountGap[m] += this.twtImpactGap[m] * currentAcMonStandardRate;
        }
        else if (this.actualsAccount[i].savingsMeasureId == 3) {
          this.twtImpactPlan[m] += currentAcMonTWTReduction * currentAcMonNoOfShifts * currentAcMonWorkingDays;
          this.twtImpactActual[m] += Number(actualUpdated) * currentAcMonNoOfShifts * currentAcMonWorkingDays;
          this.twtImpactGap[m] += this.gapActual[i][m] * currentAcMonNoOfShifts * currentAcMonWorkingDays;
          this.twtImpactAmountPlan[m] += this.twtImpactPlan[m] * currentAcMonStandardRate;
          this.twtImpactAmountActual[m] += this.twtImpactActual[m] * currentAcMonStandardRate;
          this.twtImpactAmountGap[m] += this.twtImpactGap[m] * currentAcMonStandardRate;
        }
        else if (this.actualsAccount[i].savingsMeasureId == 4) 
        { 
           if(currentAcMonTotalCost != 0)
          {
            this.costImpactPlan[m] += currentAcMonCPUSavings * currentAcMonCapacity;
          }
          this.costImpactActual[m] += Number(actualUpdated) * currentAcMonCapacity;
          this.costImpactGap[m] += this.gapActual[i][m] * currentAcMonCapacity;
        }
        else if (this.actualsAccount[i].savingsMeasureId == 5) {
          this.costImpactPlan[m] += currentAcMonTotalCost;
          this.costImpactActual[m] += Number(actualUpdated);
          this.costImpactGap[m] += this.gapActual[i][m];
        }
      }
    }
    for (var m = 0; m < 12; m++) {
      this.costImpactPlan[m] += this.twtImpactAmountPlan[m];
      this.costImpactActual[m] += this.twtImpactAmountActual[m];
      this.costImpactGap[m] += this.twtImpactAmountGap[m];
    }
  }
}